// extracted by mini-css-extract-plugin
export default {"cls1":"VeloActionBar-StyledButton_cls1__HgkDF","cls2":"VeloActionBar-StyledButton_cls2__kPY7x VeloActionBar-StyledButton_cls1__HgkDF"};